import {
  Account,
  ComplianceFlag,
  CustomFields,
  SubscriberFilter,
  SubscriberReport,
  Tags
} from "./resources"

export class SdkClient {
  constructor() {
    this.Account = new Account()
  }

  get account() {
    return this.Account
  }

  get customFields() {
    return new CustomFields()
  }

  get tags() {
    return new Tags()
  }

  get subscriberReport() {
    return new SubscriberReport()
  }

  get subscriberFilter() {
    return new SubscriberFilter()
  }

  get complianceFlag() {
    return new ComplianceFlag()
  }
}
